import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useQuery } from "@tanstack/react-query";
import { PosCommonSettings } from "@/shared/utils/interfaces";

const usePosSettingsQuery = () => {
  const branchId = useBranchId();

  const query = useQuery<PosCommonSettings>({
    queryKey: ["pos-common-settings", branchId],
    queryFn: () => get2(`internal/secure/pos/v1/possetting/get/records/${branchId}`),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });

  return { ...query };
};

export default usePosSettingsQuery;
